import React, { ChangeEvent, useState } from "react";

import type { ServerDataSuccess } from "./route";

import { ProductCard } from "~/components/ProductCard";
import { type ProductCardBase } from "types/product";

import { CarouselSection, ProductUpsellCard } from "@bared/ui";

export interface ProductUpsellsProps {
  upsellProducts: ServerDataSuccess["upsellProducts"];
}

export function ProductUpsells({ upsellProducts }: ProductUpsellsProps) {
  const [selectedVariantId, setSelectedVariantId] = useState<string | null>(
    null,
  );

  const handleSizeChange = (
    e: ChangeEvent<HTMLSelectElement>,
    variants: ProductCardBase["variants"],
  ) => {
    if (!variants) return;

    const productSize = variants.find(
      ({ size }) => size.value === e.target.value,
    );

    if (!productSize) return;

    setSelectedVariantId(productSize.id);
  };

  return (
    <ProductUpsellCard title="Pair Me With">
      {upsellProducts.map((product, index) => {
        return (
          <CarouselSection
            index={index}
            key={product.handle}
            className="!h-auto border border-primary-600"
          >
            <ProductCard
              {...product}
              className="flex [&_img]:!w-tera"
              index={index}
              sizes="80px"
              variant="upsell"
              enableAddToCart={true}
              enableWishlist={false}
              enableSheet={false}
              showColourCount={true}
              firstAvailableVariantId={
                selectedVariantId ?? product.firstAvailableVariantId
              }
              onVariantChange={(e) => handleSizeChange(e, product.variants)}
            />
          </CarouselSection>
        );
      })}
    </ProductUpsellCard>
  );
}
